<script>
import moment from 'moment';
import API from '../services/api';

const api = new API();

module.exports = {
  template: '#add-testdrivereport-template',
  data: function() {
    return {
      errors: {},
      values: {
        grade: '',
        report: ''
      },
      status: false,
      loading: false
    };
  },
  methods: {
    submitTestdriveForm: function() {
      let params = {};

      for (let key in this.values) {
        let el = this.values[key];
        if (el == '') this.errors[key] = true;
        else {
          delete this.errors[key];
          params[key] = el;
        }
      }

      for (let key in this.drive) {
        if (key !== 'grade' && key !== 'report') params[key] = this.drive[key];
      }

      if (Object.keys(this.errors).length === 0) {
        let self = this;
        self.loading = true;
        api
          .addTestdriveReport(params)
          .then(res => {
            //console.log(res);
            self.loading = false;
          })
          .catch(error => {
            //console.log(error.statusText);
          });
      }

      this.$forceUpdate();
    }
  },
  computed: {
    drive: function() {
      let id = typeof this.$route.params.id !== 'undefined' ? this.$route.params.id : false;
      let drives = this.$store.state.testdrives;

      if (drives) {
        drives = drives.reduce((result, drive) => {
          if (id == drive.vehicle_id) result = drive;

          return result;
        });
      }

      return drives;
    },
    formData: function() {
      return {
        grade: [1, 2, 3, 4, 5]
      };
    }
  }
};
</script>